(function(){
  function attach(swatch){
    var buttons=swatch.querySelectorAll('.js-variant-swatch-item');
    buttons.forEach(function(btn){
      btn.addEventListener('mouseenter', function(){
        btn.__clicked=false;
        var img=document.getElementById(btn.dataset.productImageId);
        var links=document.querySelectorAll('.'+btn.dataset.productLinkClass);
        var template=btn.querySelector('template');
        if(!img||!template) return;
        btn.__src=img.getAttribute('src');
        btn.__srcset=img.getAttribute('srcset');
        btn.__href=links.length?links[0].getAttribute('href'):null;
        var clone=template.content.firstElementChild;
        if(clone){
          if(img.getAttribute('src')) img.setAttribute('src', clone.getAttribute('src'));
          if(img.getAttribute('srcset')) img.setAttribute('srcset', clone.getAttribute('srcset')||clone.getAttribute('src'));
          links.forEach(function(link){link.setAttribute('href', clone.getAttribute('data_url'));});
        }
      });
      btn.addEventListener('mouseleave', function(){
        if(btn.__clicked) return;
        var img=document.getElementById(btn.dataset.productImageId);
        var links=document.querySelectorAll('.'+btn.dataset.productLinkClass);
        if(img&&btn.__src){
          img.setAttribute('src', btn.__src);
          if(btn.__srcset) img.setAttribute('srcset', btn.__srcset);
        }
        if(links.length&&btn.__href){
          links.forEach(function(link){link.setAttribute('href', btn.__href);});
        }
      });
      btn.addEventListener('click', function(){btn.__clicked=true;});
    });
  }
  function init(scope){
    (scope||document).querySelectorAll('sht-variant-swtch[data-hover-image="true"]').forEach(attach);
  }
  document.addEventListener('DOMContentLoaded', function(){
    init();
    if('MutationObserver' in window){
      var observer=new MutationObserver(function(mutations){
        mutations.forEach(function(m){
          m.addedNodes.forEach(function(n){
            if(n.nodeType!==1) return;
            if(n.matches&&n.matches('sht-variant-swtch[data-hover-image="true"]')){
              attach(n);
            }else if(n.querySelectorAll){
              n.querySelectorAll('sht-variant-swtch[data-hover-image="true"]').forEach(attach);
            }
          });
        });
      });
      observer.observe(document.body,{childList:true,subtree:true});
    }
  });
})();
